module.exports = __webpack_public_path__ + "img/roboto_slab+roboto.db66a89c.png";